import { Component, OnInit } from '@angular/core';
import { BaseComponent, LoadingState, SearchResult } from 'src/app/shared';
import {
  DetailSearchConfiguration,
  InpageAliasService,
  SearchRequest,
  SearchService,
  Session,
  UserRoleService,
} from '../..';
import { Title } from '@angular/platform-browser';
import { srSpeak } from '../../../shared';

@Component({
    selector: 'app-employee-search-page',
    template: `
    <app-section>
      <app-claim-breadcrumb></app-claim-breadcrumb>
      <app-panel
        title="{{ employeeAlias | titlecase }} Search"
        [headerLevel]="1"
        [canExpand]="false"
        class="tw-w-full tw-min-h-[1000px]"
        >
        <div role="search">
          <app-tab-group [hideSingleTab]="true" [tabGroupId]="'searchTabGroup'">
            @if (showEmployeeSearch) {
              <app-tab
                label="Employees"
                id="employeesTab"
                featureName="Employees"
                [template]="employee"
                >
                <ng-template #employee>
                  <div class="tw-pt-4"></div>
                  <app-detail-search-form
                    #employeeSearchForm
                    [config]="employeeConfig"
                    (search)="searchEmployees($event)"
                    (clear)="employeeLoading = 'Init'"
                    [loading]="employeeLoading"
                    loadingImageSrc="/assets/images/loader/search-results-ghost.svg"
                    >
                    <ng-template #results>
                      <app-search-count-row
                        [count]="employeeSearchResults.length"
                        resultSingle="result"
                        resultPlural="results"
                      ></app-search-count-row>
                      <app-employee-search-list
                        [searchResults]="employeeSearchResults"
                        class="tw-w-full"
                        (export)="employeeSearchForm.appendExport($event)"
                        />
                      </ng-template>
                    </app-detail-search-form>
                  </ng-template>
                </app-tab>
              }
            </app-tab-group>
          </div>
        </app-panel>
      </app-section>
    `,
    styles: [``],
    standalone: false
})
export class EmployeeSearchPageComponent
  extends BaseComponent
  implements OnInit
{
  config = new DetailSearchConfiguration();

  employeeConfig = new DetailSearchConfiguration();

  searchResults: SearchResult[];

  employeeSearchResults: SearchResult[];

  loading: LoadingState = 'Init';

  employeeLoading: LoadingState = 'Init';

  showEmployeeSearch: boolean;

  showClaimSearch: boolean;

  employeeAlias: string;

  constructor(
    public searchService: SearchService,
    public userRole: UserRoleService,
    public session: Session,
    private titleService: Title,
    private aliases: InpageAliasService
  ) {
    super();
  }

  async ngOnInit() {
    if (this.userRole.auditor) {
      this.showClaimSearch =
        this.session.user.hasLiabilityLob ||
        (this.session.user.registrationMethod === 'CLAIM' &&
          this.session.user.lineOfBusiness.some(
            (lobObj) => lobObj.lob === 'WC' || lobObj.lob === 'DS'
          ));
    }

    this.showEmployeeSearch = true;
    this.showClaimSearch = false;
    this.employeeAlias = await this.aliases.get('employeeSingular');
    this.initEmployeeConfig();
  }

  async searchEmployees(searchRequest: SearchRequest) {
    this.employeeLoading = 'Loading';
    const params = searchRequest.getParameters();
    params.isEmployeeSearch = true;
    const searchInformation = await this.searchService.getSearchResults(params);
    this.employeeSearchResults = searchInformation.searchResults;
    this.employeeLoading =
      this.employeeSearchResults.length > 0 ? 'Loaded' : 'Empty';
    if (this.employeeSearchResults && this.employeeSearchResults.length === 0) {
      srSpeak('There are no results that match the search', 'polite');
    }
  }

  private initEmployeeConfig() {
    this.employeeConfig.key = 'search-page-employees';
    this.employeeConfig.managerLookupSupervisor = true;
    this.employeeConfig.managerLookupOmni = true;
    this.employeeConfig.emptyFormAllowed = false;
    this.employeeConfig.initialValue = {
      includeIndirectReports: true,
    };

    this.employeeConfig.setVisibility(false);
    this.employeeConfig.firstName.visible = true;
    this.employeeConfig.lastName.visible = true;
    this.employeeConfig.employeeId.visible = true;
    this.employeeConfig.initialSearchMsg = `${this.employeeAlias} search results will appear here.`;
  }
}
